// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Orders_DeliverItemResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /so/orders/deliver_item/{item_id}
 *
 * Returns the item id and the UTC ISO 8601 datetime when it was delivered.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Orders_DeliverItemResponseDados {
item_id: number
delivered_at: string
}

export type Orders_DeliverItemResponse = ApiResponse<Orders_DeliverItemResponseDados>;

registerResponseContract('Orders_DeliverItemResponse', {
  item_id:      { type: 'number',  required: true },
  delivered_at: { type: 'string',  required: false },
})
